/// <amd-module name="VC/Common/CreateMenuProvider" />
import React = require("react");

import * as CommonResources from "VC/Common/Resources";

import { FastPageSwitch, onClickFPS } from "VSS/Platform/FPS";
import { IVssLayoutManager, WrappedComponent } from "VSS/Platform/Layout";
import { routeUrl } from "VSS/Platform/Location";
import { IVssPageContext, Services, VssService } from "VSS/Platform/Context";
import { IMenuItem } from "VSSUI/Menu";
import { noop } from "VSSUI/Util";
import { IMenuService } from "VSS/Features/PlatformUI/ContributedMenu";
import { ITfsPageService } from "Tfs/Platform/Page";
import { IVCNavigationService } from "VC/Common/Navigation";
import { IStartRightExtensionService } from "VSS/Platform/StartRightExtension";

class VCCreateMenuService extends VssService implements IMenuService {
    private menuItems: IMenuItem[] = [];

    public _serviceStart(pageContext: IVssPageContext) {
        super._serviceStart(pageContext);

        const vcNavigationService = this.pageContext.getService<IVCNavigationService>("IVCNavigationService");
        const vcNavigationData = vcNavigationService.getData();

        const startRightService = pageContext.getService<IStartRightExtensionService>("IStartRightExtensionService");


        if (vcNavigationData) {
            const tfsPageService = this.pageContext.getService<ITfsPageService>("ITfsPageService");
            const tfsPageData = tfsPageService.getData();

            if (tfsPageData && tfsPageData.project) {
                const projectName = tfsPageData.project.name;
                const projectId = tfsPageData.project.id;

                if (vcNavigationData.defaultGitRepoName) {
                    const routeValues: { [key: string]: string } = { project: projectName };

                    if (vcNavigationData.defaultGitRepoName !== projectName) {
                        routeValues["vc.GitRepositoryName"] = vcNavigationData.defaultGitRepoName;
                    }

                    // Create pull request
                    this.menuItems.push({
                        groupKey: "vc-actions",
                        href: routeUrl(this.pageContext, "ms.vss-code-web.pull-request-create-route", routeValues),
                        iconProps: {
                            iconName: "BranchPullRequest"
                        },
                        id: "vcNewPr",
                        onActivate: (menuItem: IMenuItem, event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => {
                            return onClickFPS(this.pageContext, menuItem.href!, true, event);
                        },
                        rank: 100,
                        text: CommonResources.NewPullRequest
                    });
                }

                // Create repository
                this.menuItems.push({
                    groupKey: "vc-actions",
                    id: "vcNewRepo",
                    onActivate: () => {
                        if (!startRightService.navigateToCreateRepository(pageContext)) {
                            const layoutManager = this.pageContext.getService<IVssLayoutManager>("IVssLayoutManager");
                            layoutManager.renderCallout(onDismiss => {
                                const onCreate = (createOperation: Promise<{ repository: { webUrl: string } }>) => {
                                    createOperation.then(result => {
                                        FastPageSwitch(this.pageContext, result.repository.webUrl, true);
                                    }, noop);
                                };

                                return (
                                    <WrappedComponent
                                        dependencies={["ms.vss-code-web.import-dependencies"]}
                                        wrappedProps={{ onCreate, onDismiss, projectId, projectName }}
                                        wrappedType="ms.vss-code-web.panel-create"
                                    />
                                );
                            });
                        }                        
                    },
                    rank: 100,
                    text: CommonResources.NewRepository
                });
            }
        }
    }

    public getMenuItems(menuId: string): IMenuItem[] | null {
        if (menuId === "ms.vss-tfs-web.vertical-header-create-menu") {
            return this.menuItems;
        }

        return null;
    }
}

Services.add("code-create-menu-provider", { serviceFactory: VCCreateMenuService });
